import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { IFetchAllDetails } from "../../../../interfaces/IPatient";
import { Button, Form, Space } from "antd";
import { Steps } from "antd";
import Member from "./CghsTabs/Member";
import Visit from "./CghsTabs/Visit";
import DocumentUpload from "./CghsTabs/DocumentUpload";
import { useUserFunctionalities } from "../../../../utils/UserFunctionalities";
import { Spin } from "antd";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";
import ResponseDocumentUploadCghsNew from "./CghsTabsNew/ResponseDocumentUploadCghsNew";
import TreatmentNew from "./CghsTabsNew/TreatmentNew";
import AdmissionDataNew from "./CghsTabsNew/AdmissionDataNew";
import PersonalHistoryNew from "./CghsTabsNew/PersonalHistoryNew";
import { DeleteOutlined } from "@ant-design/icons";
import DiagnosticData from "./CghsTabs/DiagnosticData";
import {
  getDiagnosis,
  getDiagnosisOptions,
} from "../../../../apis/SchemeService/CGHS/cghsService";
import ProcedureNew from "./CghsTabsNew/ProcedureNew";
import CareTeamDetails from "./CghsTabs/CareTeamDetails";
import AmountIncentiveDetails from "./CghsTabs/AmountIncentiveDetails";

type PreAuthCghsProps = {
  patientStore: IFetchAllDetails | null;
  portalData: any;
  activeKey: number;
  formattedAdmissionType: Array<{ label: string; value: string }>;
  formattedAdmissionTypeOp: Array<{ label: string; value: string }>;
  formattedPatientDiagnosed: Array<{ label: string; value: string }>;
  formattedConsultationType: Array<{ label: string; value: string }>;
  formattedAccreditationOptions: Array<{ label: string; value: string }>;
  formattedTreatingDoctorsOptions: Array<{ label: string; value: string }>;
  formattedProcedureReferral: Array<{ label: string; value: string }>;
  formattedProceduresOptions: Array<{ label: string; value: string }>;
  handleGetProcedureAmount: CallableFunction;
  handleGetProcedureStrats: CallableFunction;
  procedureStrats: any;
  handleDeleteProcedure: CallableFunction;
  medcoDoctors: any;
  govtHospitalList: any;
  diagnosisList: any;
  form: any;
  handleSubmit: any;
  currentVisitStage: any;
  handleSaveAsDraft: any;
  handleUpdateAsDraft: any;
  documentTypes?: any;
  handleOpen?: any;
  documentRequestResponseDocuments: any;
  handleSaveData: any;
  documentUrls: {
    documentType: string;
    documentName: string;
    documentUrl: string;
    id: number;
    referenceType: string | null;
    documentLabelType: any;
    deficiencyCheckStatus: any;
    remarks: string | null;
  }[];
  loading: boolean;
  handleFileChange: any;
  handleApprovePreAuth: any;
  isApprovedInitiated: boolean;
  isApproved: boolean;
  handleSaveConfirmationModal: any;
  getStarmarkOptions: any;
  uploadFileList: any;
  handleGetProcedureFromBill: any;
  isFetchingBillAuditProcedure: any;
  setDiagnosisData: any;
  diagnosisData: any;
  handleDeleteDoctorDetails: any;
  isFetchingBillDetails: any;
};

const { Step } = Steps;

const PreAuthCghsNew: FC<PreAuthCghsProps> = (props) => {
  const { hasFunctionality } = useUserFunctionalities();
  const { auth } = useSelector((state: RootState) => state);
  const styles: Record<string, React.CSSProperties> = {
    mainContent: {
      //   border: "0.4px solid rgb(87, 87, 87)",
      gap: "15px",
      borderRadius: "16px",
      margin: "0px 0.5rem",
    },
    statusDesign: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "20px",
      minWidth: "676px",
      maxHeight: "36px",
    },
    borderDesign: {
      minHeight: "64px",
      background: "rgb(243, 243, 243)",
      padding: "12px 35px", // Removed the semicolon and fixed the gap
      gap: "42px", // Added the gap as a separate property
      borderRadius: "16px 16px 0px 0px", // Fixed camelCase
      borderBottom: "1px solid rgb(166, 166, 166)",
      fontWeight: "600",
      fontSize: "16px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    filledBtn: {
      background: "#008B8B",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 25px",
      textTransform: "uppercase",
      color: "white",
      marginRight: "0.8rem",
    },
    blankBtn: {
      color: "#008B8B",
      background: "white",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 25px",
      marginRight: "0.8rem",
    },
    updateBtn: {
      position: "sticky",
      top: 0,
      backgroundColor: "white",
      zIndex: 998,
      padding: "10px 0",
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
    },
    intimateSubmitBtn: {
      background: "#008B8B",
      // float: "right",
      marginRight: "0.8rem",
    },
    saveBtn: {
      color: "white",
      background: "#008B8B",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 16px",
    },
    editBtn: {
      color: "#008B8B",
      background: "white",
      border: "1px solid #008B8B",
      boxShadow: "0px 2px 8px 0px #00000040",
      borderRadius: "10px",
      padding: "12px 16px",
    },
  };

  const [newDiagnosis, setNewDiagnosis] = useState<any>({
    diagnosis: "",
    // diagnosisId: "",
    diagnosisCode: "",
    type: "Primary",
  });

  const [diagnosisOptions, setDiagnosisOptions] = useState<any>([]);

  const mapDiagnosisData = (DiagnosisResponse: any) => {
    props?.setDiagnosisData(DiagnosisResponse);
  };

  useEffect(() => {
    if (props?.diagnosisData?.length > 0) {
      setNewDiagnosis({
        diagnosis: "",
        // diagnosisId: "",
        diagnosisCode: "",
        type: props?.diagnosisData?.some((item: any) => item?.type == "Primary")
          ? "Secondary"
          : "Primary",
      });

      props?.form.setFieldValue(
        "diagnosisType",
        props?.diagnosisData?.some((item: any) => item?.type == "Primary")
          ? "Secondary"
          : "Primary",
      );
    }
  }, [props?.diagnosisData]);

  useEffect(() => {
  const fetchReferralDiagnosis = async () => {
    const existingDiagnosis =
      props?.diagnosisData ?? props?.portalData?.casePreAuthCghs?.diagnosisData;

    if (existingDiagnosis?.length > 0) return;

    const referralDiagnosis =
        props?.patientStore?.referralInfoResponse?.cghsReferralResponse?.diagnosis
          ?.split(",")
          ?.map((d: string) => d.trim());

    let diagnosisList: any[] = [];

    try {
      if (props?.patientStore?.referralInfoResponse?.cghsReferralResponse?.diagnosis && referralDiagnosis?.length) {
        for (let i = 0; i < referralDiagnosis?.length; i++) {
          const response = await getDiagnosis(referralDiagnosis[i]);
          const firstResult = response?.[0];

          if (firstResult) {
            diagnosisList.push({
              diagnosis: firstResult?.diagnosisDescription,
              diagnosisCode: firstResult?.diagnosisCode,
              type: i === 0 ? "Primary" : "Secondary",
            });
          }
        }
      } else {
        const defaultSearchText = "OTHER SPECIFIED GENERAL SYMPTOMS";
          // "General examination or investigation of persons without complaint or reported diagnosis, unspecified";

        const response = await getDiagnosis(defaultSearchText);
        const firstResult = response?.[0];

        if (firstResult) {
          diagnosisList.push({
            diagnosis: firstResult?.diagnosisDescription,
            diagnosisCode: firstResult?.diagnosisCode,
            type: "Primary",
          });
        }
      }

      props?.setDiagnosisData((prev: any[]) => {
        const existingCodes = new Set(
          prev?.map((d) => d.diagnosisCode)
        );

        const filteredNew = diagnosisList?.filter(
          (d) => !existingCodes.has(d.diagnosisCode)
        );

        return [...prev, ...filteredNew];
      });

      props?.form.setFieldsValue({ selectedDiagnosis: null });

    } catch (error) {
      console.error("Error fetching diagnosis:", error);
    }
  };

  if(props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() === "OP") {
    fetchReferralDiagnosis();
  }

}, [
  props?.portalData?.casePreAuthCghs?.diagnosisData
]);

  useEffect(() => {
    const fetchInitialDiagnosisOptions = async () => {
      if (props?.patientStore?.casesResponse?.portalMetaDataIds?.[0]) {
        const diagnosisList = await getDiagnosisOptions();
        setDiagnosisOptions(diagnosisList);
      }
    };

    // fetchInitialDiagnosisOptions();
  }, [props?.patientStore?.casesResponse?.portalMetaDataIds]);

  //debouncing function for category search
  const debounceCategorySearch = (func: any, delay: number) => {
    let timeoutId: any;

    return (...args: any[]) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  const handleCategorySearch = async (value: string) => {
    if (props?.patientStore?.casesResponse?.portalMetaDataIds?.[0]) {
      // const diagnosisList = value ? await getDiagnosis(value) : await getDiagnosisOptions();
      const diagnosisList = value ? await getDiagnosis(value) : [];
      setDiagnosisOptions(diagnosisList);
    }

    props?.form.setFieldsValue({ selectedDiagnosis: null });
    setNewDiagnosis((prev: any) => ({
      ...prev,
      diagnosis: "",
      // diagnosisId: "",
      diagnosisCode: "",
    }));
  };

  //debounced function is getting returned which is need to be called
  const debouncedDiagnosisSearch = useMemo(() => {
    return debounceCategorySearch(handleCategorySearch, 300);
  }, []);

  const handleDiagnosisSelect = (diagnosisCode: string) => {
    const selectedOption = diagnosisOptions?.find(
      (option: any) => option.diagnosisCode === diagnosisCode,
    );
    if (selectedOption) {
      setNewDiagnosis({
        ...newDiagnosis,
        diagnosis: selectedOption.diagnosisDescription,
        // diagnosisId: selectedOption.diagnosisId,
        diagnosisCode: selectedOption.diagnosisCode,
      });
    }
  };

  const handleAddDiagnosis = () => {
    if (
      newDiagnosis.diagnosis &&
      newDiagnosis.diagnosisCode &&
      newDiagnosis.type
    ) {
      props?.setDiagnosisData((prev: any) => [...prev, newDiagnosis]);

      props?.form.setFieldsValue({ selectedDiagnosis: null });
    }
  };

  const handleDeleteDiagnosis = (index: number): void => {
    props?.setDiagnosisData(
      props?.diagnosisData?.filter((_: any, i: any) => i !== index),
    );
  };

  const DiagonsisColumns = [
    {
      title: "S.No.",
      dataIndex: "no",
      key: "no",
      width: 80,
      render: (_: string, r_: any, index: number) => (
        <span style={{ fontWeight: "bold" }}>{index + 1}</span>
      ),
    },
    {
      title: "Diagnosis",
      dataIndex: "diagnosis",
      key: "diagnosis",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Diagnosis Code",
      dataIndex: "diagnosisCode",
      key: "diagnosisCode",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Diagnosis Type",
      dataIndex: "type",
      key: "type",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_: any, record: any, index: number) => (
        <Space size="middle">
          <Button
            icon={
              <DeleteOutlined
                style={{
                  color: "rgb(0, 84, 157)",
                  fontSize: "17px",
                  cursor: "pointer",
                }}
                disabled={
                  props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted
                }
              />
            }
            onClick={() => handleDeleteDiagnosis(index)}
            disabled={
              props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted
            }
          />
        </Space>
      ),
    },
  ];

  return (
    <div style={styles.mainContent}>
      <Form
        form={props.form}
        //   onFinish={handleSubmit}
        labelAlign="left"
        layout="vertical"
        labelWrap
        style={{ width: "100%" }}
      >
        {/* {props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
        "OP" ? (
          <>
            <PersonalHistoryNew
              form={props?.form}
              isDisabled={props?.portalData?.casePreAuthCghs?.claimId}
            />

            <AdmissionDataNew
              form={props?.form}
              isDisabled={props?.portalData?.casePreAuthCghs?.claimId}
              doa={props?.patientStore?.visitInfoResponse?.doa}
            />

            <DiagnosticData
              form={props?.form}
              diagnosisData={props?.diagnosisData}
              newDiagnosis={newDiagnosis}
              setNewDiagnosis={setNewDiagnosis}
              diagnosisOptions={diagnosisOptions}
              handleCategorySearch={handleCategorySearch}
              handleDiagnosisSelect={handleDiagnosisSelect}
              handleAddDiagnosis={handleAddDiagnosis}
              disabledForm={
                props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                  ?.submitted
              }
              DiagonsisColumns={DiagonsisColumns}
            />
          </>
        ) : ( */}
        <>
          {props?.patientStore?.visitInfoResponse?.visitType?.toUpperCase() ===
          "OP" ? (
            <Visit
              formattedAdmissionTypeOp={props?.formattedAdmissionTypeOp}
              form={props?.form}
              portalData={props?.portalData}
              patientStore={props?.patientStore}
              isApproved={props?.isApproved}
            />
          ) : (
            <Member
              formattedAdmissionType={props?.formattedAdmissionType}
              formattedPatientDiagnosed={props?.formattedPatientDiagnosed}
              medcoDoctors={props?.medcoDoctors}
              form={props?.form}
              portalData={props?.portalData}
              patientStore={props?.patientStore}
              isApproved={props?.isApproved}
            />
          )}

          <PersonalHistoryNew
            form={props?.form}
            isDisabled={
              props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted
            }
          />
          <AdmissionDataNew
            form={props?.form}
            isDisabled={
              props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted
            }
            doa={props?.patientStore?.visitInfoResponse?.doa}
          />

          <TreatmentNew
            formattedConsultationType={props?.formattedConsultationType}
            govtHospitalList={props?.govtHospitalList}
            form={props?.form}
            diagnosisList={props?.diagnosisList}
            patientStore={props?.patientStore}
            portalData={props?.portalData}
            isApproved={props?.isApproved}
          />

          <DiagnosticData
            form={props?.form}
            diagnosisData={props?.diagnosisData}
            newDiagnosis={newDiagnosis}
            setNewDiagnosis={setNewDiagnosis}
            diagnosisOptions={diagnosisOptions}
            // handleCategorySearch={handleCategorySearch}
            handleCategorySearch={debouncedDiagnosisSearch}
            handleDiagnosisSelect={handleDiagnosisSelect}
            handleAddDiagnosis={handleAddDiagnosis}
            disabledForm={
              props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted
            }
            DiagonsisColumns={DiagonsisColumns}
          />

          <ProcedureNew
            patientDetails={props?.patientStore}
            formattedAccreditationOptions={props?.formattedAccreditationOptions}
            formattedTreatingDoctorsOptions={
              props?.formattedTreatingDoctorsOptions
            }
            formattedProcedureReferral={props?.formattedProcedureReferral}
            formattedProceduresOptions={props?.formattedProceduresOptions}
            handleGetProcedureAmount={props?.handleGetProcedureAmount}
            handleGetProcedureStrats={props?.handleGetProcedureStrats}
            procedureStrats={props?.procedureStrats}
            handleDeleteProcedure={props?.handleDeleteProcedure}
            form={props?.form}
            portalData={props?.portalData}
            isApproved={props?.isApproved}
            handleGetProcedureFromBill={props?.handleGetProcedureFromBill}
            isFetchingBillAuditProcedure={props?.isFetchingBillAuditProcedure}
            isFetchingBillDetails={props?.isFetchingBillDetails}
          />
          <CareTeamDetails
            form={props?.form}
            handleDeleteDoctorDetails={props?.handleDeleteDoctorDetails}
            portalData={props?.portalData}
          />
          <AmountIncentiveDetails form={props.form} isClaimStage={false} />
        </>
        {/* )} */}
      </Form>

      {props?.loading ? (
        <div
          style={{
            margin: "auto",
            width: "100%,",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        props?.documentRequestResponseDocuments?.["requestedDocuments"]
          ?.length > 0 && (
          <DocumentUpload
            documentTypes={props?.documentTypes}
            documentUrls={props?.documentUrls}
            handleFileChange={props?.handleFileChange}
            handleOpen={props?.handleOpen}
            portalSubmission={
              props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted
            }
            documentRequestResponseDocuments={
              props?.documentRequestResponseDocuments
            }
            getStarmarkOptions={props?.getStarmarkOptions}
            uploadFileList={props?.uploadFileList}
            isIntimated={
              props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.intimated
            }
          />
        )
      )}

      {props?.documentRequestResponseDocuments?.["responseDocuments"]?.length >
        0 && (
        <ResponseDocumentUploadCghsNew
          documentTypes={props?.documentTypes}
          documentUrls={props?.documentUrls}
          handleFileChange={props?.handleFileChange}
          handleOpen={props?.handleOpen}
          portalSubmission={
            props?.portalData?.casePreAuthCghs?.casePreAuthResponse?.submitted
          }
          documentRequestResponseDocuments={
            props?.documentRequestResponseDocuments
          }
          handleSaveData={props?.handleSaveData}
          currentStage={props?.currentVisitStage}
          activeKey={props?.activeKey}
          uploadFileList={props?.uploadFileList}
        />
      )}

      {/* Navigation buttons */}
      <div
        style={{
          marginTop: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: "30px",
          borderTop: "1px solid #D9D9D9",
          padding: "15px 20px",
        }}
      >
        {
          <>
            {!props?.portalData?.casePreAuthCghs?.casePreAuthResponse
              ?.submitted ? (
              <>
                {props?.portalData?.casePreAuthCghs?.id &&
                !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                  ?.initiated ? (
                  // && !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                  //   ?.approved
                  // && !(
                  //   auth?.role?.role == "FO_STAFF" &&
                  //   props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                  //     ?.intimated
                  // )
                  <div style={{ width: "16%" }}>
                    <Button
                      type="primary"
                      style={{
                        backgroundColor: "rgb(0, 76, 143)",
                        color: "#fff",
                        boxShadow: "0px 2px 8px 0px #00000040",
                        width: "100%",
                      }}
                      // onClick={props?.handleUpdateAsDraft}
                      onClick={() =>
                        props?.handleSaveConfirmationModal("update")
                      }
                    >
                      UPDATE
                    </Button>
                  </div>
                ) : (
                  !props?.portalData?.casePreAuthCghs?.id && (
                    <div style={{ width: "16%" }}>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          width: "100%",
                        }}
                        // onClick={props?.handleSaveAsDraft}
                        onClick={() =>
                          props?.handleSaveConfirmationModal("save")
                        }
                      >
                        SAVE
                      </Button>
                    </div>
                  )
                )}

                {hasFunctionality("casePreAuthIntimate") &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.intimated &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.initiated &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.approved && (
                    <div style={{ width: "16%" }}>
                      <Button
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          width: "100%",
                        }}
                        className="me-2"
                        // onClick={() => handleSaveIhx()}
                        onClick={() =>
                          props?.handleSaveConfirmationModal("intimate")
                        }
                      >
                        Send To QC
                      </Button>
                    </div>
                  )}

                {hasFunctionality("preAuthApprover") &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.initiated &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.approved &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted && (
                    <div style={{ width: "16%" }}>
                      <Button
                        loading={props?.isApprovedInitiated}
                        className="me-2"
                        // onClick={handleApprovePreAuth}
                        onClick={() =>
                          props?.handleSaveConfirmationModal("approve")
                        }
                        disabled={props?.isApproved}
                        // style={{ }}
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          width: "100%",
                          opacity: !props?.isApproved ? 1 : 0.5,
                          pointerEvents: !props?.isApproved ? "auto" : "none",
                        }}
                        // style={{display: "flex", alignItems: "center", background: "#008B8B", border: "1px solid #008B8B", boxShadow: "0px 2px 8px 0px #00000040", borderRadius: "10px", padding: "12px 25px"}}
                      >
                        QC Approve
                      </Button>
                    </div>
                  )}

                {hasFunctionality("casePreAuthSubmission") &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.initiated &&
                  !props?.portalData?.casePreAuthCghs?.casePreAuthResponse
                    ?.submitted && (
                    <div style={{ width: "16%" }}>
                      <Button
                        type="primary"
                        style={{
                          backgroundColor: "rgb(0, 76, 143)",
                          color: "#fff",
                          boxShadow: "0px 2px 8px 0px #00000040",
                          width: "100%",
                        }}
                        onClick={props?.handleSubmit}
                      >
                        {props?.patientStore?.casesResponse
                          ?.integratedWithPortal
                          ? "Initiate"
                          : "Submit Manually"}
                      </Button>
                    </div>
                  )}
              </>
            ) : (
              <></>
            )}
          </>
        }
      </div>
    </div>
  );
};

export default PreAuthCghsNew;
